import { render, staticRenderFns } from "./Glosowanie.vue?vue&type=template&id=d709d6e0"
import script from "./Glosowanie.vue?vue&type=script&lang=js"
export * from "./Glosowanie.vue?vue&type=script&lang=js"
import style0 from "./Glosowanie.vue?vue&type=style&index=0&id=d709d6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.103.0_@swc+core_f91a0a1053829af0a77e207d835d75dd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports